import {
  ERROR_CREATE_EXTERNAL_USER,
  ERROR_DELETE_EXTERNAL_USER,
  ERROR_EXTERNAL_USER,
  ERROR_GET_EXTERNAL_ROLE,
  ERROR_GET_EXTERNAL_ROLE_BY_ID,
  ERROR_GET_EXTERNAL_USER_BY_ID,
  LOADING_CREATE_EXTERNAL_USER,
  LOADING_DELETE_EXTERNAL_USER,
  LOADING_EXTERNAL_USER,
  LOADING_GET_EXTERNAL_ROLE,
  LOADING_GET_EXTERNAL_ROLE_BY_ID,
  LOADING_GET_EXTERNAL_USER_BY_ID,
  SUCCESS_CREATE_EXTERNAL_USER,
  SUCCESS_DELETE_EXTERNAL_USER,
  SUCCESS_GET_EXTERNAL_ROLE,
  SUCCESS_GET_EXTERNAL_ROLE_BY_ID,
  SUCCESS_GET_EXTERNAL_USERS,
  SUCCESS_GET_EXTERNAL_USER_BY_ID,
} from '../../const/actionTypes';
import { IDataBundleUser } from '../../interfaces/dataBundleUser';
import { IPrivilege } from '../../interfaces/privilege';
import { IRoleData } from '../../interfaces/roleData';

interface IInitialState {
  loading: boolean;
  loadingRoleById: boolean;
  deletingUser: boolean;
  creatingUser: boolean;
  loadingDataObject: boolean;
  error: string;
  dataBundle: IDataBundleUser[];
  roleDataBundle: IRoleData[];
  loadingRoleData: boolean;
  roleDataObject?: IRoleData;
  rolePrivilegeDataBundle: IPrivilege[];
  dataObject?: IDataBundleUser;
}

const initialState: IInitialState = {
  loading: false,
  loadingRoleById: false,
  deletingUser: false,
  creatingUser: false,
  loadingDataObject: false,
  loadingRoleData: false,
  error: '',
  dataBundle: [],
  roleDataBundle: [],
  roleDataObject: undefined,
  rolePrivilegeDataBundle: [],
  dataObject: undefined,
};

export type ExternalUserState = Readonly<typeof initialState>;

const externalUserReducer = (
  state = initialState,
  action: any
): ExternalUserState => {
  switch (action.type) {
    case LOADING_EXTERNAL_USER: {
      return {
        ...state,
        loading: true,
      };
    }

    case SUCCESS_GET_EXTERNAL_USERS: {
      return {
        ...state,
        loading: false,
        dataBundle: action.payload,
      };
    }

    case ERROR_EXTERNAL_USER: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case LOADING_GET_EXTERNAL_ROLE: {
      return {
        ...state,
        loadingRoleData: true,
      };
    }

    case SUCCESS_GET_EXTERNAL_ROLE: {
      return {
        ...state,
        loadingRoleData: false,
        roleDataBundle: action.payload,
      };
    }

    case ERROR_GET_EXTERNAL_ROLE: {
      return {
        ...state,
        loadingRoleData: false,
      };
    }

    case LOADING_DELETE_EXTERNAL_USER: {
      return {
        ...state,
        deletingUser: true,
      };
    }

    case SUCCESS_DELETE_EXTERNAL_USER:
    case ERROR_DELETE_EXTERNAL_USER: {
      return {
        ...state,
        deletingUser: false,
      };
    }

    case LOADING_CREATE_EXTERNAL_USER: {
      return {
        ...state,
        creatingUser: true,
      };
    }

    case SUCCESS_CREATE_EXTERNAL_USER:
    case ERROR_CREATE_EXTERNAL_USER: {
      return {
        ...state,
        creatingUser: false,
      };
    }

    case LOADING_GET_EXTERNAL_ROLE_BY_ID: {
      return {
        ...state,
        loadingRoleById: true,
      };
    }

    case SUCCESS_GET_EXTERNAL_ROLE_BY_ID: {
      return {
        ...state,
        loadingRoleById: false,
        roleDataObject: action.payload,
        rolePrivilegeDataBundle: action.payload.privileges,
      };
    }

    case ERROR_GET_EXTERNAL_ROLE_BY_ID: {
      return {
        ...state,
        loadingRoleById: false,
      };
    }

    case LOADING_GET_EXTERNAL_USER_BY_ID: {
      return {
        ...state,
        loadingDataObject: true,
      };
    }

    case SUCCESS_GET_EXTERNAL_USER_BY_ID: {
      return {
        ...state,
        loadingDataObject: false,
        dataObject: action.payload,
      };
    }

    case ERROR_GET_EXTERNAL_USER_BY_ID: {
      return {
        ...state,
        loadingDataObject: false,
      };
    }

    default:
      return state;
  }
};

export default externalUserReducer;
